var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Spinner, SpinnerSize, TooltipHost, Icon } from "../../fluent";
import { useEffect, useState } from "react";
import React from "react";
export const FileUploadItem = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [percentage, setPercentage] = useState(0);
    const maxChunkSize = 8388608; // 8Mb
    const { name, error } = props.file;
    const errorMessage = error ? 'El archivo no se ha cargado. Puede eliminarlo y cargarlo de nuevo o reintentar la carga haciendo clic aquí' : '';
    const uploadFileAsync = (item, startChunk, options) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        let nextChunk = startChunk;
        // Actualizar porcentaje
        if (item.size > 0) {
            setPercentage(Math.floor((nextChunk / item.size) * 100));
        }
        while (true) {
            // Obtener un trozo del archivo a cargar
            const chunkSize = item.size > maxChunkSize ? maxChunkSize : item.size; // Tamaño del pedazo
            const endRead = nextChunk + chunkSize; // Byte final a leer
            const lengthRead = endRead > item.size ? item.size : endRead; // Tamaño final del pedazo a leer
            const buffer = item.nativeFile.slice(nextChunk, lengthRead); // Leer parte del archivo
            // Enviar archivo al servidor
            const chunkResult = yield options.onAppend(buffer);
            nextChunk = chunkResult.NextChunk;
            // Actualizar porcentaje
            if (item.size > 0) {
                setPercentage(Math.floor((nextChunk / item.size) * 100));
            }
            // Si el siguiente el igual al tamaño del archivo quiere decir que se completo la carga
            if (nextChunk === item.size) {
                item.nativeFile = null;
                options.onComplete(data => item.data = data);
                break;
            }
        }
        setIsLoading(false);
        props.onComplete(item);
    });
    const startProcessAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        const isNew = props.file.isNew && props.file.nativeFile != null;
        if (isNew) {
            if (typeof props.onCreate === 'function') {
                const { name, size } = props.file.nativeFile;
                const options = yield props.onCreate(name, size, props.file.uploadId);
                if (!options.cancel) {
                    yield uploadFileAsync(props.file, 0, options);
                }
            }
        }
    });
    const retryProcess = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.onchange = (ev) => {
            var _a, _b;
            if (((_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) === 1) {
                if (typeof props.onRetry === 'function') {
                    const { name, size } = ev.target.files[0];
                    const options = props.onRetry(props.file, name, size);
                    if (!options.cancel) {
                        uploadFileAsync({
                            error: false,
                            uploadId: '',
                            nativeFile: ev.target.files[0],
                            size,
                            name,
                            isNew: false
                        }, options.nextChunk, options);
                    }
                }
            }
        };
        input.click();
    };
    const onClick = () => {
        if (isLoading) {
            if (props.onMessage != null) {
                props.onMessage('Archivo en proceso de carga', 'Visor documentos');
            }
            return;
        }
        if (!error) {
            props.onClick();
        }
        else {
            if (props.onMessage != null) {
                props.onMessage('El archivo no ha sido cargado', 'Visor documentos');
            }
            return;
        }
    };
    useEffect(() => { startProcessAsync(); }, []);
    return React.createElement("div", null,
        React.createElement("span", { style: { cursor: 'pointer' }, onClick: onClick }, name),
        (error && !isLoading) && React.createElement("span", null,
            "\u00A0",
            React.createElement(TooltipHost, { content: errorMessage },
                React.createElement(Icon, { onClick: retryProcess, style: {
                        color: "#ff5722",
                        fontWeight: 700,
                        fontSize: "14px",
                        position: "absolute",
                        marginTop: "2px",
                        marginLeft: "4px",
                        cursor: "pointer"
                    }, iconName: 'Warning' }))),
        isLoading && React.createElement("span", { style: { float: 'right' } },
            React.createElement(Spinner, { size: SpinnerSize.small, style: { float: 'left', marginRight: '5px' } }),
            " ",
            percentage,
            "%"));
};
